import React, { Component } from 'react';
import { connect, } from 'react-redux';
import { CloseButton, Container, Modal, Spinner, Placeholder, PlaceholderButton, Card } from 'react-bootstrap';
import { withRouter } from './withRouter';
import PageSEO from 'components/Utlility/PageSEO';
import { getGameSeoOverrides } from 'constants/SeoConfig';
import Help from "../components/Help";
import Analytics from "analytics";

import { getGameList, findGameById, findGameBySlug, getAddons } from "constants/GameListAdapter";
import styles from './ShopAddonStyles.module.scss'
import Game from './Games/Game';
import GameAddon from './Games/GameAddon';
import AddonModal from './AddonModal/AddonModal';
import { addToCart } from 'actions/cart';
import DotLoader from 'components/Utlility/DotLoader';
import TrustBoxContainer, { TRUSTPILOT_TEMPLATES } from './TrustWidget';


import time from 'animations/time-black.png'
import players from 'animations/minPlayers-black.png'

import age6Black from "animations/ageRatings/age-6.png";
import age8Black from "animations/ageRatings/age-8.png";
import age10Black from "animations/ageRatings/age-10.png";
import age12Black from "animations/ageRatings/age-12.png";
import age14Black from "animations/ageRatings/age-14.png";


import placeHolderDesktop from 'images/gameStorePreviews/placeholder-desktop.svg';
import placeHolderMobile from 'images/gameStorePreviews/placeholder-mobile.svg';
import loadingDesktop from 'images/gameStorePreviews/loading-desktop.svg';
import loadingMobile from 'images/gameStorePreviews/loading-mobile.svg';
import placeHolderLogo from 'images/gameLogos/placeholder-logo.svg';
import loadingLogo from 'images/gameLogos/loading-logo.svg';
import placeHolderBackground from 'images/storeBackgrounds/placeholder-background.svg';
import loadingBackground from 'images/storeBackgrounds/loading-background.svg';
import { disable } from 'workbox-navigation-preload';
import PricingFunctions from '../common/PricingFunctions';

import { APP_TYPES } from "constants/AppTypes";
import WebIcon from "images/icons/web-icon.png";
import FireTVIcon from "images/icons/FireTV-Icon.png";
import RokuIcon from "images/icons/Roku-Icon-v2.png";


const howItWorksBlocks = [
    {
        number: 1,
        title: "GET IT ON THE BIG SCREEN",
        //"description": "Only one person needs to own the games. They will be 'party leader' and it's their job to get Game.City up on the biggest screen they can. Use Teams, Zoom or Discord if you want to play online. Use a smart TV to open it with a browser or connect up with a laptop and HDMI. Once you have achieved that, simply log in to your account."
        "description": "Open Game.City on Fire TV, Roku, smart TV, or laptop and log in!"
    },
    {
        number: 2,
        title: "GATHER SOME FRIENDS",
        //description: "Gather some friends, either online or in the same room. Once you have Game.City on the screen and you're logged in, players simply need to scan the QR code to join in, or head to Game.City and join using the Room Code.",
        description: "Scan the QR code or enter the Room Code at Game.City.",
    },
    {
        number: 3,
        title: "PLAY AND HAVE FUN",
        //description: "Once joined, choose a potato avatar, change your nickname and then choose a game. Get playing and have a great time. All our online games are extra family friendly so everyone can enjoy!"
        description: "Choose an avatar, pick a game, and enjoy"
    }
];

class ShopAddon extends Component {
    static displayName = ShopAddon.name;

    constructor(props) {
        super(props);

        const addon = this.getAddon();
        this.state = {
            showHowToPlay: false,
            isLoading: true,
            baseGame: addon ? getGameList().find((x) => addon.forGameId === x.gameId) : null,
        };
    }

    /**
     * Get the addon object - either from props or by looking up from URL slug.
     * This handles the case where routes are defined before games are loaded from API.
     */
    getAddon() {
        // If addon prop exists, use it
        if (this.props.addon) {
            return this.props.addon;
        }
        // Otherwise, look up by URL slug (games loaded async from API)
        return findGameBySlug(this.props.location.pathname);
    }
    // Safe getter for preview images with placeholder fallback
    getPreviewImage(type) {
        const previewImages = this.getAddon()?.meta?.previewImages;

        // Show loading placeholder while images are being preloaded
        if (this.state.isLoading) {
            return type.includes('mobile') ? loadingMobile : loadingDesktop;
        }

        const image = previewImages?.[type];
        if (image) return image;

        // Fallback to missing placeholder when no image exists
        return type.includes('mobile') ? placeHolderMobile : placeHolderDesktop;
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.initializeAddon();
    }

    componentDidUpdate(prevProps) {
        // Re-initialize if addon wasn't loaded before but is now
        const addon = this.getAddon();
        const prevAddon = prevProps.addon || findGameBySlug(prevProps.location?.pathname);
        if (!prevAddon && addon) {
            this.initializeAddon();
        }
    }

    initializeAddon() {
        console.log("modal", this.ref);
        const addon = this.getAddon();
        if (addon) {
            Analytics.viewContent(addon.productId);

            const images = [
                this.getAddon().meta?.storeBackground,
                this.getAddon().logo,
                this.getAddon().meta?.previewImages?.mobile1,
                this.getAddon().meta?.previewImages?.desktop1,
                this.getAddon().meta?.previewImages?.desktop2,
                this.getAddon().meta?.previewImages?.mobile2,
            ].filter(Boolean);
            Promise.all(images.map(image => {
                return new Promise((resolve, reject) => {
                    const img = new Image();
                    img.onload = resolve;
                    img.onerror = reject;
                    img.src = image;
                });
            })).then(() => {
                setTimeout(() => {
                    this.setState({ isLoading: false });
                }, 100);
            }).catch(error => {
                // if there's an error, we still want to show the app, so set isLoading to false
                this.setState({ isLoading: false });
            });
        } else {
            this.props.navigate("/shop");
        }
    }

    getStoreBackground() {
        // Show loading placeholder while images are being preloaded
        const bg = this.state.isLoading
            ? loadingBackground
            : (this.getAddon()?.meta?.storeBackground || placeHolderBackground);
        return {
            backgroundColor: this.getAddon()?.meta?.storeBackgroundColour || '#2a2a2a',
            backgroundImage: `url(${bg})`,
        }
    }

    getLogo() {
        // Show loading placeholder while images are being preloaded
        if (this.state.isLoading) return loadingLogo;
        // Fallback to missing placeholder when no logo exists
        return this.getAddon()?.logo || placeHolderLogo;
    }

    getStoreAccentBorder() {
        return {
            backgroundColor: this.getAddon()?.meta.storeAccentColour,
            border: `10px solid ${this.getAddon()?.meta.storeAccentColour}`
        }
    }

    getStoreAccentBackground() {
        return {
            backgroundColor: this.getAddon()?.meta.storeAccentColour,
            border: `10px solid ${this.getAddon()?.meta.storeAccentColour}`
        }
    }

    getStoreAccentImageBorder() {
        return {
            border: `2px solid ${this.getAddon()?.meta.storeAccentColour}`
        }
    }

    getStoreInfoBackground() {
        return {
            backgroundColor: `${this.getAddon()?.meta.storeInfoBackground}`
        }
    }
    goToBaseGame = (e) => {
        e.preventDefault();
        this.props.navigate(this.state.baseGame.storeSlug)
    }

    addGameToCart(game) {
        if (this.shouldShowAddonModal()) this.setState({ showAddonModal : true});
        else this.props.addToCart(game);
    }

    addonModalCallback = ()=>{
        this.setState({ showAddonModal: false });
    }

    shouldShowAddonModal() {
        const ownsBaseGame = !!this.props.auth.user?.games.find(g => g.code === this.state.baseGame.gameId);
        const baseGameIsInCart = !!this.props.cart.items.find(i => i.productId === this.state.baseGame.productId);
        return !(ownsBaseGame || baseGameIsInCart)
    }

    getPrice() {
        let countryCode = this.props.pricing.countryCode;
        let pricing = PricingFunctions.getGamePricing(countryCode, this.getAddon());
        return pricing.display;
    }

    closeHelpModal = () => {
        this.setState({ showHowToPlay: false, });
    }

    getAgeIcon() {
        switch (this.props.game?.gameInfo.minAge) {
            case 6:
                return age6Black;
            case 8:
                return age8Black;
            case 10:
                return age10Black;
            case 12:
                return age12Black;
            case 14:
                return age14Black;
            default:
                return age8Black;
        }
    }

    getSupportedPlatforms() {
        if (!this.getAddon()) return;

        let platforms = [];
        for (let i = 0; i < this.getAddon().supportedPlatforms.length; i++) {
            let platform = this.getAddon().supportedPlatforms[i];
            let img = null;
            let link = null;

            switch (platform) {
                case APP_TYPES.WEB:
                    img = WebIcon;
                    break;
                case APP_TYPES.FIRE_TV:
                    img = FireTVIcon;
                    link = "https://www.amazon.co.uk/Game-City-Game-City/dp/B0FCYQ3QY7/ref=sr_1_6?crid=1HYZ8KROZPE3Q&dib=eyJ2IjoiMSJ9.8FmPt9aRPWTU9EIjS4v9rBc1OzkR5g7FwwI6Bts_C4nD1Hos0s_FKTAEzgkEW5MWoFy-Z7AN9cDeW70SMLQ_JiDh_WU6x3PrH2CxLSmUbHPBgWA-UszU3foPJtC0pK2aseieTBMCVzwS2Ez2UeKVh-cjY5p_0E_fqYRG4qAfYscIMoOKn-1jKWxS-RpyIw9lgpr8JUMQaSZyq_COX2MO3SKsoyShTzZONoktuJoNTJkVJ2fcS4g_iGAU5y-Qy8g45K9Cah0IEH2EkelWFkIHmt6SKaU8FDTL3FTD90uElsk.DYEAaB96KVfdhfMuXvjklBo42TKSgftMh4AT_oE44mU&dib_tag=se&keywords=Game+City&qid=1756198594&sprefix=game+city%2Caps%2C104&sr=8-6";
                    break;
                case APP_TYPES.ROKU:
                    img = RokuIcon;
                    link = "https://channelstore.roku.com/en-gb/details/f40f6c4e12bfb9b619aa4530404178ea:bf00789f9ba54a68d7fc648d46ddbfc5/game-city-party-games-on-tv";
                    break;
                default:
                    break;
            }

            if (img != null) {
                if (link != null) {
                    platforms.push(
                        <div className={styles.platform}>
                            <a href={link} target="_blank">
                                <img src={img} />
                            </a>
                        </div>
                    )
                } else {
                    platforms.push(
                        <div className={styles.platform}>
                            <img src={img} />
                        </div>
                    )
                }
            }
        }

        return platforms;
    }


    render() {
        return (
            <React.Fragment>
                {(() => {
                    const addon = this.getAddon();
                    const seoOverrides = getGameSeoOverrides(addon?.storeSlug);
                    const title = seoOverrides?.title || `Play ${addon?.name} on Your TV | Game.city`;
                    const description = seoOverrides?.description || addon?.description;
                    const canonical = `https://game.city${addon?.storeSlug}`;
                    return <PageSEO title={title} description={description} canonical={canonical} robots="index, follow" />;
                })()}
                {this.state.showAddonModal && <AddonModal ref={this.ref} addon={this.getAddon()} baseGame={this.state.baseGame} callback={this.addonModalCallback} ></AddonModal>}
                <div className={styles.pageShopSingle} style={this.getStoreBackground()}>
                    <section className={`${styles.band}`}>
                        <Container className="text-center">
                            <div className='row'>
                                <div className='offset-xl-1 col-xl-10'>
                                    {/*<div className={styles.backButton}>*/}
                                    {/*    <button onClick={() => this.props.navigate("/shop")} className={`${styles.button} ${styles.alternate} ${styles.small}`} style={{ width: "fit-content" }}><BiLeftArrowAlt /> Back</button>*/}
                                    {/*</div>*/}
                                    <div className={styles.gameLogo}>
                                        <img src={this.getLogo()} className={`${styles.storeLogo} ${this.getAddon()?.meta?.storeLogo2 && styles.hasSecond}`} alt={`${this.getAddon()?.name} Logo`} />
                                        {this.getAddon()?.meta?.storeLogo2 && <img src={this.getAddon()?.meta?.storeLogo2} className={styles.storeLogo2} alt={`${this.getAddon()?.name} logo`}></img>}
                                    </div>
                                    {/* {console.log(this.state.game.gameInfo?.minAge)} */}
                                    <div className='row'>
                                        <div className='col-lg-8 order-2 order-lg-1 text-center'>
                                            <div className={`${styles.previewImages} d-none d-lg-block`} style={{ ...this.getStoreAccentBorder(), ...this.getStoreAccentBackground() }}>
                                                <div className={styles.imageRow}>
                                                    <div style={this.getStoreAccentImageBorder()}>
                                                        <img className={styles.mobilePreview} src={this.getPreviewImage('mobile1')}></img>
                                                    </div>
                                                    <div style={this.getStoreAccentImageBorder()}>
                                                        <img className={styles.desktopPreview} src={this.getPreviewImage('desktop1')}></img>
                                                    </div>
                                                </div>
                                                <div className={styles.imageRow}>
                                                    <div style={this.getStoreAccentImageBorder()}>
                                                        <img className={styles.desktopPreview} src={this.getPreviewImage('desktop2')}></img>
                                                    </div>
                                                    <div style={this.getStoreAccentImageBorder()}>
                                                        <img className={styles.mobilePreview} src={this.getPreviewImage('mobile2')}></img>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className={`${styles.previewImages} ${styles.mobile} d-block d-lg-none`} style={this.getStoreAccentBorder()}>
                                                <div className={`${styles.imageRow} ${styles.singleDesktopRow}`}>
                                                    <div style={this.getStoreAccentImageBorder()}>
                                                        <img src={this.getPreviewImage('desktop1')}></img>
                                                    </div>
                                                </div>
                                                <div className={`${styles.imageRow} ${styles.singleDesktopRow}`}>
                                                    <div style={this.getStoreAccentImageBorder()}>
                                                        <img src={this.getPreviewImage('desktop2')}></img>
                                                    </div>
                                                </div>
                                                <div className={`${styles.imageRow} ${styles.doubleColRow}`}>
                                                    <div style={this.getStoreAccentImageBorder()}>
                                                        <img src={this.getPreviewImage('mobile1')}></img>
                                                    </div>
                                                    <div style={this.getStoreAccentImageBorder()}>
                                                        <img src={this.getPreviewImage('mobile2')}></img>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        <div className='col-lg-4 order-1 order-lg-2'>
                                            <div className={styles.gameInfoWrapper} style={this.getStoreInfoBackground()}>
                                                <h1 className={styles.seoHeading}>{getGameSeoOverrides(this.getAddon()?.storeSlug)?.h1 || `Play ${this.getAddon()?.name} on Your TV`}</h1>
                                                <div className={styles.addonBannerWrapper} >
                                                    <div className={styles.addonBanner}>Add-on</div>
                                                </div>
                                                {/*<h3 className={styles.addonHeader}>GAME ADDON</h3>*/}
                                                <p className={styles.gamePrice}><strong>{this.getPrice() || <DotLoader size="medium" variant="dark" />}</strong></p>

                                                <button className={styles.button} onClick={() => this.addGameToCart(this.getAddon())} disabled={this.getAddon().price === 0} >{this.state.loading ? <DotLoader size="medium" variant="dark" /> : this.getAddon().price === 0 ? "Auto Redeemed" : "Add To Cart"}</button>
                                                {/*<br />*/}
                                                {/*<button className={`${styles.button} ${styles.small} alternate}`} onClick={() => this.setState({ showHowToPlay: true, })}>{this.state.loading ? <Spinner animation="border" /> : "How To Play"}</button>*/}


                                                <ul className={styles.gameInfo}>
                                                    <li>
                                                        <div className={styles.icon}>
                                                            <img src={time} />
                                                        </div>
                                                        <span>{this.getAddon().gameInfo?.avgRoundLengthText}</span>
                                                    </li>
                                                    <li>
                                                        <div className={styles.icon}>
                                                            <img src={players} />
                                                        </div>
                                                        <span>{this.getAddon().gameInfo?.minPlayers}-{this.getAddon().gameInfo?.maxPlayers ?? 8} Players</span>
                                                    </li>
                                                    <li>
                                                        <div className={styles.icon}>
                                                            <img src={this.getAgeIcon()} />
                                                        </div>
                                                        <span>
                                                            Age {this.getAddon().gameInfo?.minAge}+
                                                        </span>
                                                    </li>
                                                </ul>

                                                <hr></hr>

                                                <ul className={styles.gameDescription}>
                                                    {this.getAddon().gameInfo?.descriptions.map(description => {
                                                        return (<li>
                                                            <p className={styles.descriptionHeader}>{description.header}</p>
                                                            <p className={styles.descriptionBody}>{description.body}</p>
                                                        </li>)
                                                    })}
                                                </ul>

                                                <div className={styles.requiredGameSection} style={{ "background": `${this.getAddon()?.meta.storeAccentColour}` }} >
                                                    <p className={styles.header}>Requires</p>
                                                    <img className={styles.gameCard} src={this.state.baseGame.meta?.storeTinyCard} onClick={ this.goToBaseGame} alt="required"></img>
                                                </div>

                                                {
                                                    <>
                                                        <hr></hr>
                                                        <p className={styles.header} style={{color: "black"}}>Supported Platforms</p>
                                                        <div className={styles.platformsList}>
                                                            {this.getSupportedPlatforms()}
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Container>
                    </section>
                    <section className={`${styles.band} ${styles.sm}`} style={this.getStoreAccentBackground()}>
                    {/*<section className={`${styles.band} ${styles.subContent}`}>*/}
                        {/*<div className={styles.cityBG} style={{ width: "100%", height: "100%", position: "absolute" }}></div>*/}

                        <Container>

                            {/*<div className="row text-center my-5" id="how-it-works">*/}
                            {/*    <h2 className='text-uppercase mb-1'>Unsure about how it works?</h2>*/}
                            {/*    <h4 className={`${styles.subTitle} text-uppercase`}>Playing a party game on your TV might sound like magic, but don't worry<br />it's as easy as 1-2-3.</h4>*/}
                            {/*    <div className={`${styles.howItWorksBox} py-3`}>*/}
                            {/*        {*/}
                            {/*            howItWorksBlocks.map((x) => {*/}
                            {/*                return <div className={`${styles.howItWorksBlock} my-3`}>*/}
                            {/*                    <div className={styles.number}>*/}
                            {/*                        <p>{x.number}</p>*/}
                            {/*                    </div>*/}
                            {/*                    <h3 className={styles.title}>{x.title}</h3>*/}
                            {/*                    <p className={styles.description}>{x.description}</p>*/}
                            {/*                </div>*/}
                            {/*            })*/}
                            {/*        }*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            <div className={`row text-center justify-content-center `}>
                                {this.getAddon()?.gameUpsellIds?.length > 0 && <>
                                    <h2 className='text-uppercase mt-5'>Others you might like</h2>
                                    {getAddons().filter((x) => this.getAddon().gameUpsellIds.includes(x.gameId)).map(g => <div className='col-md-6 col-lg-4 text-center'><GameAddon addon={g} key={g.gameId} /></div>)}
                                    {getGameList().filter((x) => x.type === 'Game' && this.getAddon().gameUpsellIds.includes(x.gameId)).map(g => <div className='col-md-6 col-lg-4 text-center'><Game showAddToCart={true} game={g} key={g.gameId} /></div>)}
                                </>}
                            </div>
                        </Container>
                    </section>
                    <section className={styles.reviewsSection}>
                        <div className="container">
                            <TrustBoxContainer
                                templateId={TRUSTPILOT_TEMPLATES.CAROUSEL}
                                height="240px"
                                width="100%"
                                theme="dark"
                                stars="5"
                            />
                        </div>
                    </section>
                </div>
                <Modal show={this.state.showHowToPlay} onHide={this.closeHelpModal} contentClassName={styles.rounded} >
                    <CloseButton style={{ position: "absolute" }} onClick={this.closeHelpModal} />
                    <Help />
                </Modal>

            </React.Fragment>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        pricing: state.pricing,
        cart: state.cart
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        addToCart: (game) => {
            dispatch(addToCart(game))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ShopAddon));
